import { UserType, Me } from '../../types';

export function isEmployee(user: Me) {
  return user.permissions.godMode;
}

export function getUserType(user: Me): UserType {
  if (user.permissions.network) {
    return UserType.network;
  }

  if (user.permissions.podcast) {
    return UserType.podcast;
  }

  return UserType.empty;
}
